import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface InspectionConfigurationSearchCriteria extends BasePagedSearchCriteria{

    provider?:string;
}


export const INSPECTION_CONF_SEARCH_CRITERIA_KEY = 'InspectionConfigurationSearchCriteria';